import { render, staticRenderFns } from "./Profile.html?vue&type=template&id=066a8507&"
import script from "./Profile.js?vue&type=script&lang=js&"
export * from "./Profile.js?vue&type=script&lang=js&"
import style0 from "./profile.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports